/** @flow */
import type { SpawnEffect } from "redux-saga";
import { spawn } from "redux-saga/effects";
import myNotificationsSaga from "./my-notifications";

export default function* notificationsSaga(): Generator<
  SpawnEffect<*, typeof myNotificationsSaga, *>,
  void,
  void,
> {
  yield spawn(myNotificationsSaga);
}
